import { styled } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";
import leadpixieLogo from "../../../assets/leadpixie_logo.png"

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
  width: "100%",
  flexDirection: "row",

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}));

const StyledCaption = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  variant: "caption",
  component: "span",
  color: "#424343",
  // font: "normal normal 400 16px open sans",

  [[theme.breakpoints.between("xs", "sm")]]: {
    font: "normal normal 400 8px open sans",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    font: "normal normal 400 10px open sans",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 12px open sans",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 16px open sans",
  },
}));

const FooterComponent = ({ contentState }) => {
  return (
    <Container>
      {/* Left spacer – only on md+ */}
      <Box
        sx={{
          minWidth: 160,
          display: { xs: "none", md: "block" },
        }}
      />

      {/* Footer text */}
      <Box sx={{ flex: 1, textAlign: "center" }}>
        <StyledCaption>
          {contentState.footer_text}{" "}
          {contentState.pp_link ? (
            <a href={contentState.pp_link} target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
          ) : (
            "Privacy Policy"
          )}
        </StyledCaption>
      </Box>

      {/* Powered by */}
      <Box
        component="a"
        href="https://leadpixie.ai"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 0.75,
          mr: { xs: 0, md: 2 },
          borderRadius: 999,
          minWidth: { md: 160 },
          mt: { xs: 1, md: 0 },

          bgcolor: "rgba(255, 255, 255, 0.9)",
          border: "1.5px solid rgba(33, 88, 159, 0.4)",
          textDecoration: "none",
          whiteSpace: "nowrap",

          transition: "border-color 0.25s ease",
          "&:hover": { borderColor: "#21589F" },

          // center it on mobile
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.75rem",
            fontWeight: 500,
            color: "#111",
          }}
        >
          Powered by
        </Typography>

        <Box
          component="img"
          src={leadpixieLogo}
          alt="Leadpixie"
          sx={{ height: 10 }}
        />
      </Box>
    </Container>
  );
};

export default FooterComponent;
